import React, { useState, useRef, useEffect } from "react";
import useStyles from "./style";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  IconButton,
  TextField,
  Drawer,
  Typography,
  Grid,
  MenuItem,
  Button,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import { Close, LocationOn } from "@mui/icons-material";
import CustomSwitch from "SharedComponents/CustomSwitch";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";

// Components from Bookingform
import DistanceAndRate from "../Bookingform/DistanceDuration";
import Estimatedcarousel from "../Bookingform/Estimatedcarousel";
import Assigndriver from "../Bookingform/Createtripform/Assigndriver";

// Services
import DispatcherApi from "Services/Dispatcher";
import PackageDeliveryTypeApi from "Services/PackageDeliveryType";

import { getCountryCodes } from "Utils/country";

const PackageBookingForm = ({
  openPackageBooking,
  setOpenPackageBooking,
  userType,
  subcmpnyName,
  demoaccount_id,
  setOrigin,
  setDestination,
  origin,
  destination,
  setMapCenter,
  services,
  timezone,
  registerReset,
  onOpen,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const activeDemoAccountId = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || demoaccount_id || ""
  );

  // Map & Autocomplete States
  const [pickupLatLng, setPickupLatLng] = useState(null);
  const [dropLatLng, setDropLatLng] = useState(null);
  const [distance, setDistance] = useState(null);
  const [duration, setDuration] = useState(null);
  const [travelDuration, setTravelduration] = useState("");
  const activecarouselRef = useRef(null);

  const [pickupInput, setPickupInput] = useState("");
  const [pickupSuggestions, setPickupSuggestions] = useState([]);
  const [dropInput, setDropInput] = useState("");
  const [dropSuggestions, setDropSuggestions] = useState([]);

  const autocompleteService = useRef(null);
  const placesServiceRef = useRef(null);

  console.log(services);

  // Country code states
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [senderCountryCode, setSenderCountryCode] = useState("");
  const [receiverCountryCode, setReceiverCountryCode] = useState("");

  // Assign Driver Modal States
  const [autoassign, setAutoassign] = useState(false);
  const [assigndriverModal, setAssigndriverModal] = useState(false);
  const [dialogFormValues, setDialogFormValues] = useState({});

  // Package Delivery Types
  const [packageDeliveryTypes, setPackageDeliveryTypes] = useState([]);

  useEffect(() => {
    const fetchPackageDeliveryTypes = async () => {
      try {
        const params = { limit: "unlimited" };
        // if (activeDemoAccountId) {
        //   params.demoaccount_id = activeDemoAccountId;
        // }
        const res = await PackageDeliveryTypeApi.getPackageDeliveryTypesList(params);
        if (res?.data?.status === true) {
          const list =
            res?.data?.data?.data ||
            res?.data?.data?.TotalPackages ||
            res?.data?.data ||
            [];
          setPackageDeliveryTypes(Array.isArray(list) ? list : []);
        }
      } catch (err) {
        console.error("Error fetching package delivery types:", err);
      }
    };
    fetchPackageDeliveryTypes();
  }, [activeDemoAccountId]);

  const packageServices = (services || []).filter(
    (s) =>
      s?.fareDetails?.deliveryType === true ||
      s?.fareDetails?.deliveryType === "true" ||
      s?.deliveryType === true ||
      s?.deliveryType === "true" ||
      s?.fareDetails?.TruckType === true ||
      s?.fareDetails?.TruckType === "true" ||
      s?.TruckType === true ||
      s?.TruckType === "true"
  ); 

  const displayedServices =
    packageServices && packageServices.length > 0 ? packageServices : (services || []);


  useEffect(() => {
    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }
  }, []);

  useEffect(() => {
    if (
      !placesServiceRef.current &&
      window.google &&
      document.getElementById("map-temp-package")
    ) {
      placesServiceRef.current = new window.google.maps.places.PlacesService(
        document.getElementById("map-temp-package")
      );
    }
  }, []);

  // Fetch Country Codes
  useEffect(() => {
    try {
      const countries = getCountryCodes();
      setCountryCodeData(countries);
      if (countries && countries.length > 0) {
        setSenderCountryCode(countries[0].dial_code || countries[0].code || "");
        setReceiverCountryCode(countries[0].dial_code || countries[0].code || "");
      }
    } catch (error) {
      console.error("Error fetching country codes:", error);
    }
  }, []);



  // Expose reset function to parent
  useEffect(() => {
    if (registerReset) {
      registerReset(() => {
        formik.resetForm();
        setPickupInput('');
        setPickupSuggestions([]);
        setDropInput('');
        setDropSuggestions([]);
        setPickupLatLng(null);
        setDropLatLng(null);
        setDistance(null);
        setDuration(null);
        setTravelduration('');
        setAutoassign(false);
        if (setOrigin) setOrigin('');
        if (setDestination) setDestination('');
      });
    }
  }, [registerReset]);

  // Handle Pickup Places Autocomplete
  const handlePickupChange = (e) => {
    const value = e.target.value;
    setPickupInput(value);
    if (value.length >= 6 && autocompleteService.current) {
      autocompleteService.current.getPlacePredictions(
        { input: value },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setPickupSuggestions(predictions || []);
          } else {
            setPickupSuggestions([]);
          }
        }
      );
    } else {
      setPickupSuggestions([]);
    }
  };

  const handlePickupSelect = (placeId, description) => {
    if (placesServiceRef.current) {
      placesServiceRef.current.getDetails({ placeId }, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          setPickupLatLng({ lat, lng });
          setPickupInput(description);
          if (setOrigin) setOrigin(description);
          setPickupSuggestions([]);
        }
      });
    }
  };

  // Handle Drop Places Autocomplete
  const handleDropChange = (e) => {
    const value = e.target.value;
    setDropInput(value);
    if (value.length >= 6 && autocompleteService.current) {
      autocompleteService.current.getPlacePredictions(
        { input: value },
        (predictions, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            setDropSuggestions(predictions || []);
          } else {
            setDropSuggestions([]);
          }
        }
      );
    } else {
      setDropSuggestions([]);
    }
  };

  const handleDropSelect = (placeId, description) => {
    if (placesServiceRef.current) {
      placesServiceRef.current.getDetails({ placeId }, (place, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          const lat = place.geometry.location.lat();
          const lng = place.geometry.location.lng();
          setDropLatLng({ lat, lng });
          setDropInput(description);
          if (setDestination) setDestination(description);
          setDropSuggestions([]);
        }
      });
    }
  };

  const togglePackageDrawer = (isOpen) => () => {
    setOpenPackageBooking(isOpen);
  };

  const roundedInputStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "25px",
      backgroundColor: "#f5f5f5",
    },
  };

  // Formik Form Validation & Setup
  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      senderPhone: "",
      receiverPhone: "",
      notesForDriver: "",
      parcel_type: "",
      isScheduled: false,
      scheduledTime: "",
      autoAssignDriver: false,
    },
    validationSchema: yup.object({
      first_name: yup.string().required("First Name is required"),
      last_name: yup.string(),
      email: yup
        .string()
        .email("Invalid email format")
        .required("Email is required"),
      senderPhone: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Sender Phone Number is required"),
      receiverPhone: yup
        .string()
        .matches(/^\d{1,15}$/, "Invalid mobile number")
        .required("Receiver Phone Number is required"),
      parcel_type: yup
        .string()
        .test(
          "parcel-type-required",
          "Type of Parcel is required",
          function (val) {
            if (packageDeliveryTypes && packageDeliveryTypes.length > 0) {
              return Boolean(val && val.trim());
            }
            return true;
          }
        ),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (!pickupLatLng || !dropLatLng) {
        dispatch(
          showSnackbar({
            message: "Please select valid Pickup and Dropoff locations from suggestions",
            variant: "error",
          })
        );
        return;
      }

      if (!activecarouselRef.current?.service_id) {
        dispatch(
          showSnackbar({
            message: "Please select a vehicle / delivery service",
            variant: "error",
          })
        );
        return;
      }

      const payload = {
        // Location fields (matches Createtripform)
        s_address: pickupInput,
        s_latitude: pickupLatLng.lat,
        s_longitude: pickupLatLng.lng,
        d_address: dropInput,
        d_latitude: dropLatLng.lat,
        d_longitude: dropLatLng.lng,
        distance: distance,
        minutes: travelDuration,

        // Service (matches Createtripform key: service_type)
        service_type: activecarouselRef.current?.service_id,
        estimatedFare: activecarouselRef.current?.estimated_fare,

        // Customer info (matches Createtripform)
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        countryCode: senderCountryCode,
        mobile: values.senderPhone,

        // Package-specific extras (receiver info)
        receiverCountryCode: receiverCountryCode,
        receiverPhone: values.receiverPhone,

        // Package parcel type
        parcel_type: values.parcel_type || "",

        // Notes (matches Createtripform key: userNotes)
        userNotes: values.notesForDriver,

        // Driver assignment (matches Createtripform key: autoassigndriver)
        autoassigndriver: autoassign,

        // Scheduling (matches Createtripform)
        isScheduled: values.isScheduled,
        scheduledTime: values.scheduledTime,

        // Booking meta (matches Createtripform)
        bookingType: "USER",
        userType: userType,
        subcmpnyName: subcmpnyName,
        demoaccount_id: activeDemoAccountId,

        // Package flag
        isPackage: true,
      };

      if (!autoassign) {
        setDialogFormValues(payload);
        setAssigndriverModal(true);
      } else {
        submitPackageBooking(payload);
      }
    },
  });

  const submitPackageBooking = (payloadData) => {
    dispatch(showLoader("Creating package booking..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message:
              res?.data?.message || "Package booking created successfully",
            variant: "success",
          })
        );
        formik.resetForm();
        setPickupInput("");
        setDropInput("");
        setPickupLatLng(null);
        setDropLatLng(null);
        setOpenPackageBooking(false);
        navigate("/package-delivery-triplist");
      } else {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Failed to create booking",
            variant: "error",
          })
        );
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message:
            err?.response?.data?.message ||
            "Error occurred while creating package booking",
          variant: "error",
        })
      );
    };

    DispatcherApi.createridebydispatcher(payloadData).then(
      onSuccess,
      onFailure
    );
  };



  return (
    <>
      {/* Trigger Button Image */}
      <img
        src="/assets/images/logos/Add-parcel.png"
        alt="Open Package Booking"
        aria-label="open package booking drawer"
        onClick={() => { if (onOpen) onOpen(); togglePackageDrawer(true)(); }}
        style={{ width: "80px", height: "80px" }}
        className={classes.bookingiconbuttonopen}
        sx={{ ...(openPackageBooking && { display: "none" }) }}
      />

      {/* Close Icon Button */}
      <IconButton
        className={classes.formboxcloseicon}
        onClick={togglePackageDrawer(false)}
        sx={{
          opacity: openPackageBooking ? 1 : 0,
          visibility: openPackageBooking ? "visible" : "hidden",
          transition: "opacity 0.3s ease-in-out, visibility 0.3s ease-in-out",
        }}
      >
        <Close />
      </IconButton>

      {/* Drawer Container */}
      <Drawer
        className={classes.drawerformbox}
        variant="persistent"
        anchor="right"
        open={openPackageBooking}
      >
        <Box className={classes.bookingformbox}>
          <div className={classes.booking_header}>
            <Typography variant="h5" component="h2">
              Package & Logistics Booking
            </Typography>
          </div>
          <div id="map-temp-package" style={{ display: "none" }}></div>

          {/* Autocomplete Locations */}
          <div className={classes.autocomplete_control}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                position: "relative",
                width: "100%",
              }}
            >
              {/* Pickup Location */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <img
                  src="/assets/images/DispatcherIcons/startlocation.png"
                  alt="Pickup Location"
                  style={{
                    position: "absolute",
                    left: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "24px",
                    height: "24px",
                  }}
                />
                <TextField
                  id="pickuplocation_package"
                  label="Pickup Location"
                  variant="outlined"
                  size="small"
                  value={pickupInput}
                  onChange={handlePickupChange}
                  className={classes.autocomplete_inputs}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    zIndex: 5,
                    background: "#fff",
                    boxShadow: 3,
                    maxHeight: 200,
                    overflowY: "auto",
                  }}
                >
                  {pickupSuggestions.map((suggestion) => (
                    <Box
                      key={suggestion.place_id}
                      sx={{
                        padding: 1,
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#eee" },
                      }}
                      onClick={() =>
                        handlePickupSelect(
                          suggestion.place_id,
                          suggestion.description
                        )
                      }
                    >
                      {suggestion.description}
                    </Box>
                  ))}
                </Box>
              </Box>

              {/* Dotted Line */}
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Box
                  sx={{
                    height: 35,
                    top: 0,
                    width: 2,
                    background: "gray",
                    marginLeft: "18px",
                    opacity: 0.5,
                    borderLeft: "2px dotted gray",
                  }}
                />
              </Box>

              {/* Drop Location */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                <LocationOn
                  sx={{
                    color: "red",
                    position: "absolute",
                    left: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
                <TextField
                  id="droplocation_package"
                  label="Drop Location"
                  variant="outlined"
                  size="small"
                  value={dropInput}
                  onChange={handleDropChange}
                  className={classes.autocomplete_inputs}
                />
                <Box
                  sx={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    zIndex: 5,
                    background: "#fff",
                    boxShadow: 3,
                    maxHeight: 200,
                    overflowY: "auto",
                  }}
                >
                  {dropSuggestions.map((suggestion) => (
                    <Box
                      key={suggestion.place_id}
                      sx={{
                        padding: 1,
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#eee" },
                      }}
                      onClick={() =>
                        handleDropSelect(
                          suggestion.place_id,
                          suggestion.description
                        )
                      }
                    >
                      {suggestion.description}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Box>
          </div>

          {/* Distance and duration calculation */}
          <DistanceAndRate
            pickupLatLng={pickupLatLng}
            dropLatLng={dropLatLng}
            origin={origin}
            destination={destination}
            distance={distance}
            duration={duration}
            setMapCenter={setMapCenter}
            setDistance={setDistance}
            setDuration={setDuration}
          />

          {/* Form to create package/logistics trip */}
          <form onSubmit={formik.handleSubmit}>
            <Grid container rowSpacing={1} className={classes.containerformik}>
              {/* Schedule Ride Toggle */}
              <Grid item xs={12} className={classes.switchWrapper}>
                <Grid item lg={5}>
                  <Typography variant="body1">Schedule Ride</Typography>
                </Grid>
                <Grid item lg={7}>
                  <FormControlLabel
                    control={
                      <CustomSwitch
                        checked={formik.values.isScheduled}
                        onChange={(e) =>
                          formik.setFieldValue("isScheduled", e.target.checked)
                        }
                      />
                    }
                  />
                </Grid>
              </Grid>

              {formik.values.isScheduled && (
                <Grid item xs={12} className={classes.formikgrids}>
                  <TextField
                    id="scheduledTime"
                    label="Schedule Date & Time"
                    type="datetime-local"
                    value={formik.values.scheduledTime}
                    onChange={formik.handleChange}
                    fullWidth
                    variant="standard"
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              )}

              {/* Estimated Carousel – delivery-type services with fallback */}
              {displayedServices && displayedServices.length > 0 && (
                <Grid item xs={12} className={classes.formikgrids}>
                  <Estimatedcarousel
                    distance={distance}
                    duration={duration}
                    services={displayedServices}
                    setTravelduration={setTravelduration}
                    timezone={timezone}
                    activecarouselRef={activecarouselRef}
                  />
                </Grid>
              )}

              {/* Type of Parcel */}
              <Grid item xs={12} className={classes.formikgrids}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, marginBottom: "6px", color: "#374151" }}
                >
                  Type of Parcel
                </Typography>
                <TextField
                  select
                  id="parcel_type"
                  name="parcel_type"
                  value={formik.values.parcel_type}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.parcel_type &&
                    Boolean(formik.errors.parcel_type)
                  }
                  helperText={
                    formik.touched.parcel_type && formik.errors.parcel_type
                  }
                  sx={roundedInputStyle}
                  fullWidth
                  variant="outlined"
                  size="small"
                  SelectProps={{
                    displayEmpty: true,
                    renderValue: (selected) => {
                      if (!selected) {
                        return (
                          <span style={{ color: "#9ca3af" }}>
                            Select Type of Parcel
                          </span>
                        );
                      }
                      const matched = packageDeliveryTypes.find(
                        (item) => item?.packageName === selected
                      );
                      return (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          {matched?.packageImage && (
                            <img
                              src={matched.packageImage}
                              alt={selected}
                              style={{
                                width: 22,
                                height: 22,
                                borderRadius: "4px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          <span>{selected}</span>
                        </Box>
                      );
                    },
                  }}
                >
                  <MenuItem value="" disabled>
                    <span style={{ color: "#9ca3af" }}>Select Type of Parcel</span>
                  </MenuItem>
                  {packageDeliveryTypes
                    .filter(
                      (item) =>
                        item?.status === undefined ||
                        item?.status === 1 ||
                        item?.status === "1"
                    )
                    .map((item) => (
                      <MenuItem
                        key={item._id || item.packageName}
                        value={item.packageName}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                          {item.packageImage && (
                            <img
                              src={item.packageImage}
                              alt={item.packageName}
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "4px",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          <span>{item.packageName}</span>
                        </Box>
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>

              {/* First Name */}
              <Grid item xs={6} className={classes.formikgrids}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, marginBottom: "6px", color: "#374151" }}
                >
                  First Name
                </Typography>
                <TextField
                  id="first_name"
                  name="first_name"
                  label="First Name"
                  value={formik.values.first_name}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.first_name && Boolean(formik.errors.first_name)
                  }
                  helperText={
                    formik.touched.first_name && formik.errors.first_name
                  }
                  sx={roundedInputStyle}
                  fullWidth
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Last Name */}
              <Grid item xs={6} className={classes.formikgrids}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, marginBottom: "6px", color: "#374151" }}
                >
                  Last Name
                </Typography>
                <TextField
                  id="last_name"
                  name="last_name"
                  label="Last Name"
                  value={formik.values.last_name}
                  onChange={formik.handleChange}
                  sx={roundedInputStyle}
                  fullWidth
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Email */}
              <Grid item xs={12} className={classes.formikgrids}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, marginBottom: "6px", color: "#374151" }}
                >
                  Email
                </Typography>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  sx={roundedInputStyle}
                  fullWidth
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Sender Phone Number */}
              <Grid item xs={12} className={classes.formikgrids}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, marginBottom: "6px", color: "#374151" }}
                >
                  Sender Phone Number
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Autocomplete
                      id="senderCountryCode"
                      options={countryCodeData}
                      autoHighlight
                      getOptionLabel={(option) =>
                        `${option.code || ""} (${option.dial_code || ""})`
                      }
                      value={
                        countryCodeData.find(
                          (c) =>
                            c.dial_code === senderCountryCode ||
                            c.code === senderCountryCode
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setSenderCountryCode(
                          newValue?.dial_code || newValue?.code || ""
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          label="Code"
                          variant="outlined"
                          sx={roundedInputStyle}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      id="senderPhone"
                      name="senderPhone"
                      label="Sender Phone Number"
                      value={formik.values.senderPhone}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.senderPhone &&
                        Boolean(formik.errors.senderPhone)
                      }
                      helperText={
                        formik.touched.senderPhone && formik.errors.senderPhone
                      }
                      sx={roundedInputStyle}
                      fullWidth
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Receiver Phone Number */}
              <Grid item xs={12} className={classes.formikgrids}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, marginBottom: "6px", color: "#374151" }}
                >
                  Receiver Phone Number
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Autocomplete
                      id="receiverCountryCode"
                      options={countryCodeData}
                      autoHighlight
                      getOptionLabel={(option) =>
                        `${option.code || ""} (${option.dial_code || ""})`
                      }
                      value={
                        countryCodeData.find(
                          (c) =>
                            c.dial_code === receiverCountryCode ||
                            c.code === receiverCountryCode
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        setReceiverCountryCode(
                          newValue?.dial_code || newValue?.code || ""
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          label="Code"
                          variant="outlined"
                          sx={roundedInputStyle}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      id="receiverPhone"
                      name="receiverPhone"
                      label="Receiver Phone Number"
                      value={formik.values.receiverPhone}
                      onChange={formik.handleChange}
                      error={
                        formik.touched.receiverPhone &&
                        Boolean(formik.errors.receiverPhone)
                      }
                      helperText={
                        formik.touched.receiverPhone && formik.errors.receiverPhone
                      }
                      sx={roundedInputStyle}
                      fullWidth
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* Notes For Driver */}
              <Grid item xs={12} className={classes.formikgrids}>
                <Typography
                  variant="body2"
                  sx={{ fontWeight: 500, marginBottom: "6px", color: "#374151" }}
                >
                  Notes For Driver
                </Typography>
                <TextField
                  id="notesForDriver"
                  name="notesForDriver"
                  label="Notes For Driver"
                  multiline
                  rows={2}
                  value={formik.values.notesForDriver}
                  onChange={formik.handleChange}
                  sx={roundedInputStyle}
                  fullWidth
                  variant="outlined"
                  size="small"
                />
              </Grid>

              {/* Auto Assign Driver Toggle */}
              <Grid item xs={12} className={classes.switchWrapper}>
                <Grid item lg={5}>
                  <Typography variant="body1">Auto Assign Driver</Typography>
                </Grid>
                <Grid item lg={7}>
                  <FormControlLabel
                    control={
                      <CustomSwitch
                        checked={autoassign}
                        onChange={() => setAutoassign((prev) => !prev)}
                      />
                    }
                  />
                </Grid>
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12} sx={{ mt: 2, mb: 2, textAlign: "center" }}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: "25px",
                    padding: "10px",
                    fontWeight: 700,
                    textTransform: "none",
                    fontSize: "15px",
                    backgroundColor: theme.palette.custom?.main || "#000",
                    color: "#fff",
                    "&:hover": {
                      backgroundColor: "#333",
                    },
                  }}
                >
                  Create Trip
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Drawer>

      {/* Driver Assignment Modal */}
      {assigndriverModal && (
        <Assigndriver
          openDialog={assigndriverModal}
          assigndriverModal={assigndriverModal}
          setAssigndriverModal={setAssigndriverModal}
          formvalues={dialogFormValues}
          formValues={dialogFormValues}
          handleClose={() => setAssigndriverModal(false)}
          handledisagree={() => setAssigndriverModal(false)}
          userType={userType}
          subcmpnyName={subcmpnyName}
          onSuccessCallback={() => {
            setAssigndriverModal(false);
            setOpenPackageBooking(false);
            formik.resetForm();
            setPickupInput("");
            setDropInput("");
            setPickupLatLng(null);
            setDropLatLng(null);
            navigate("/package-delivery-triplist");
          }}
        />
      )}
    </>
  );
};

export default PackageBookingForm;
